import {
  setEmployees,
  setIsUpdateEmployees,
} from "../../../store/slices/employeesSlice";
import { setLogin, setUser } from "../../../store/slices/userSlice";
import { errorToast, infoToast } from "../../methods/toast";
import { $authHost, $host } from "../http";
import { getModelAiList } from "./models";

const storeToken = async (value) => {
  try {
    await localStorage.setItem("@storage_Token", value);
  } catch (error) {
    console.log(error);
  }
};

const storeId = async (value) => {
  try {
    await localStorage.setItem("@storage_User_Id", value);
  } catch (error) {
    console.log(error);
  }
};

export const registerUser = (dataAuth, setLoading, setError) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $host.post("/user/sign-up", dataAuth);

      if (data.user) {
        setLoading(false);
        dispatch(setUser(data.user));
      } else {
        setLoading(false);
        errorToast("Ошибка регистрации!");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 500) {
          setError("Ошибка на сервере. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Попробуйте снова.");
      } else {
        errorToast("Произошла ошибка. Попробуйте позже.");
      }
      console.log("Error reg", error);
    }
  };
};

export const authUser = (dataAuth, setLoading, setError) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $host.post("/user/sign-in", dataAuth);

      if (data.token) {
        setLoading(false);
        storeToken(data.token);
        storeId(data.user.id);
        dispatch(setLogin(data.token));
        dispatch(getModelAiList());
        dispatch(setUser(data.user));
        localStorage.setItem("@user_Data", JSON.stringify(data.user));
      } else {
        setLoading(false);
        setError("Неправильный логин или пароль. Попробуйте снова.");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 500) {
          setError("Ошибка на сервере. Попробуйте позже.");
          errorToast("Ошибка на сервере. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Попробуйте снова.");
      } else {
        errorToast("Произошла ошибка. Попробуйте позже.");
      }
      console.log("Error auth", error);
    }
  };
};

export const addEmployee = (
  dataEmployee,
  setLoading,
  requestComplete,
  setIsUserAdd
) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post("/user/employee/add", dataEmployee);
      if (data.code === 200) {
        setLoading(false);
        dispatch(getEmployeeList(dataEmployee.id));
        requestComplete();
        setIsUserAdd(false);
      } else {
        setLoading(false);
        errorToast("Произошла ошибка");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Попробуйте снова.");
      } else {
        errorToast("Произошла ошибка. Попробуйте позже.");
      }
      console.log("Error addEmployee", error);
    }
  };
};

export const updateEmployee = (dataEmployee, setLoading) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.put(
        "/user/employee/update",
        dataEmployee
      );
      if (data.code === 200) {
        setLoading(false);
        dispatch(getEmployeeList(dataEmployee.id));
        dispatch(setIsUpdateEmployees(false));
        infoToast("Сотрудник был успешно обновлен");
      } else {
        setLoading(false);
        errorToast("Произошла ошибка");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Попробуйте снова.");
      } else {
        errorToast("Произошла ошибка. Попробуйте позже.");
      }
      console.log("Error updateEmployee", error);
    }
  };
};

export const deleteEmployee = (userId, employeeId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.delete(
        `/user/employee/delete?userId=${userId}&employeeId=${employeeId}`
      );
      if (data.code === 200) {
        console.log("deleteEmployee", data);
        dispatch(getEmployeeList(userId));
      } else {
        errorToast("Произошла ошибка");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Попробуйте снова.");
      } else {
        errorToast("Произошла ошибка. Попробуйте позже.");
      }
      console.log("Error deleteEmployee", error);
    }
  };
};

export const getEmployeeList = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/user/employees/get?userId=${userId}`
      );
      if (data.code === 200) {
        dispatch(setEmployees(data.employees));
        if (data.employees) {
          localStorage.setItem("employeesData", JSON.stringify(data.employees));
        }
      } else {
        errorToast("Произошла ошибка");
        // setError("Неправильный логин или пароль. Попробуйте снова.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Попробуйте снова.");
      } else {
        errorToast("Произошла ошибка. Попробуйте позже.");
      }
      console.log("Error getEmployeeList", error);
    }
  };
};
